const WuAmerigoConfigs = (() => {
    const elementAmerigoSetting = document.getElementById('amerigo_settings');
    const configs = elementAmerigoSetting && JSON.parse(elementAmerigoSetting.innerHTML);
    const isEnvProd = stringExists(location.href,['www.westernunion.com','www2.westernunion.com']);
    return {
        isAmerigo: () => configs && configs.is_amerigo,
        getChannel: () => configs && configs.channel,
        getClient: (channelType) => configs && (isEnvProd ? configs[`PROD_${channelType}`] : configs[`UAT_${channelType}`]),
        getTopCountries: () => configs && configs.amerigo_top_countries
    }
})();